import * as yup from "yup";

export const FormSchema =
  [
    {
      step: 1,
      validations:
        yup.object({
          email: yup.string().email('Ingrese un email valido').required('Este campo es requerido'),
          emailConfirmation: yup.string().email('Ingrese un email valido')
            .oneOf([yup.ref('email'), null], 'Los correos no coinciden').required('Este campo es requerido'),
          password: yup.string().min(6, 'La contraseña debe tener minimo 6 caracteres').required('Este campo es requerido'),
          password_confirmation: yup.string().min(6, 'La contraseña debe tener minimo 6 caracteres')
            .oneOf([yup.ref('password'), null], 'Las contraseñas no coinciden').required('Este campo es requerido'),
        }).required()
    },
    {
      step: 2,
      validations:
        yup.object({
          document_type: yup.string().required('Este campo es requerido'),
          citizen_id: yup.string().required('Este campo es requerido'),
          name: yup.string().required('Este campo es requerido'),
          first_last_name: yup.string().required('Este campo es requerido'),
          second_last_name: yup.string(),
          occupation: yup.string(),
          province_id: yup.string().required('Este campo es requerido'),
          municipality_id: yup.string().required('Este campo es requerido'),
          sector_id: yup.string().required('Este campo es requerido'),
          phone: yup.string().required('Este campo es requerido'),
          phone2: yup.string().notOneOf([yup.ref('phone')], 'El teléfono secundario no puede ser igual al teléfono primario'),
          email2: yup.string().email('Ingrese un email valido'),
          address: yup.string().required('Este campo es requerido'),
        }).required()
    },
    {
      step: 3,
      validations:
        yup.object({
          first_citizen_question: yup.number().required('Este campo es requerido'),
          first_citizen_answer: yup.string().required('Este campo es requerido'),
          second_citizen_question: yup.number().required('Este campo es requerido'),
          second_citizen_answer: yup.string().required('Este campo es requerido'),
          third_citizen_question: yup.number().required('Este campo es requerido'),
          third_citizen_answer: yup.string().required('Este campo es requerido'),
        }).required()
    },
    {
      step: 4,
      validations:
        yup.object({
          termsAndCondition: yup.boolean().oneOf([true], 'Debe aceptar los terminos y condiciones de uso y privacidad para continuar')
        }).required()
    },
  ]

export const RegisterSteps = [
  {
    title: 'Información de Autenticación',
    elements: [
      'email',
      'emailConfirmation',
      'password',
      'password_confirmation'
    ]
  },
  {
    title: 'Datos Personales',
    elements: [
      'document_type',
      'citizen_id',
      'name',
      'first_last_name',
      'second_last_name',
      'occupation',
      'province_id',
      'municipality_id',
      'sector_id',
      'phone',
      'phone2',
      'email2',
      'address'
    ]
  },
  {
    title: 'Información de seguridad',
    elements: [
      'first_citizen_question',
      'first_citizen_answer',
      'second_citizen_question',
      'second_citizen_answer',
      'third_citizen_question',
      'third_citizen_answer',
    ]
  },
  {
    title: 'Términos y condiciones',
    elements: [
      'termsAndCondition'
    ]
  },
  {
    title: 'Activación de cuenta'
  }
];

export const identificationTypes = [
  {
    value: 1,
    label: 'Cédula'
  },
  {
    value: 2,
    label: 'Pasaporte'
  },
];

export const termsAndConditionData = `
<!-- wp:heading {"level":1} -->
<h1>Terminos y condiciones</h1>
<!-- /wp:heading -->
<!-- wp:heading {"level":3} -->
<h3>Términos de Uso y su Aceptación</h3>
<!-- /wp:heading -->
<div >
<!-- Content -->
<p>La presente Política de Privacidad establece los términos en que La Universidad Abierta Para Adultos (UAPA) usa y protege la información que es proporcionada por sus usuarios al momento de utilizar su sitio web. Esta universidad está comprometida con la seguridad de los datos de sus usuarios. Cuando le pedimos llenar los campos de información personal lo hacemos asegurando que sólo se empleará de acuerdo con los términos de este documento. Sin embargo, esta Política de Privacidad puede cambiar con el tiempo o ser actualizada por lo que le recomendamos y enfatizamos revisar continuamente esta página para asegurarse que está de acuerdo con dichos cambios.</p>
<p><strong>INFORMACIÓN QUE ES RECOGIDA</strong></p>
<p>Nuestro sitio web podrá recoger información personal, por ejemplo: Nombre,&nbsp;información de contacto como su dirección de correo electrónica e información demográfica. Así mismo cuando sea necesario podrá ser requerida información específica para procesar la solicitud de algún servicio.</p>
<p><strong>USO DE LA INFORMACIÓN RECOGIDA</strong></p>
<p>Nuestro sitio web emplea la información con el fin de proporcionar el mejor servicio posible, particularmente para mantener un registro de usuarios, de prospectos en caso que aplique, y mejorar nuestros productos y servicios. &nbsp;Es posible que sean enviados correos electrónicos periódicamente a través de nuestro sitio con ofertas especiales, eventos, noticias y otra información publicitaria que consideremos relevante para usted o que pueda brindarle algún beneficio, estos correos electrónicos serán enviados a la dirección que usted proporcione.</p>
<p>La Universidad Abierta Para Adultos (UAPA) está altamente comprometida para cumplir con el compromiso de mantener su información personal segura y constantemente tratamos de que no exista ningún acceso no autorizado.</p>
<p><strong>ENLACES A TERCEROS</strong></p>
<p>Este sitio web pudiera contener enlaces a otros sitios que pudieran ser de su interés. Una vez que usted de clic en estos enlaces y abandone nuestra página, ya no tenemos control sobre al sitio al que es redirigido y por lo tanto no somos responsables de los términos o privacidad ni de la protección de sus datos en esos otros sitios terceros. Dichos sitios están sujetos a sus propias políticas de privacidad por lo cual es recomendable que los consulte para confirmar que usted está de acuerdo con estas.</p>
<p><strong>CONTROL DE SU INFORMACIÓN PERSONAL</strong></p>
<p>Esta Universidad no venderá, cederá ni distribuirá la información personal que es recopilada sin su consentimiento, salvo que sea requerido por un juez con una orden judicial.</p>
<p>La Universidad Abierta Para Adultos (UAPA) se reserva el derecho de cambiar los términos de la presente Política de Privacidad en cualquier momento.</p>
<!-- Mostrar info: Experiencia universitaria  -->
<!-- .entry-content -->
</div>
`

export const cedulaDB = [
  {
    id: '22355598575',
    name: 'Jeniffer',
    lastName: "Segura",
    secondLastName: "Wilkinson",
    province: "DO01",
    municipe: "DO0101",
    sector: "DO0101010103001",
    address: "Calle 1ra numero 10"
  },
  {
    id: '00154865652',
    name: 'Radek',
    lastName: "Corrado",
    secondLastName: "Ungar",
    province: "DO32",
    municipe: "DO3201",
    sector: "DO3201010101506",
    address: "Calle 1ra numero 10"
  },
  {
    id: '00178452316',
    name: 'Guillermo',
    lastName: "Leman",
    secondLastName: "Weller",
    province: "DO25",
    municipe: "DO2501",
    sector: "DO2501010100702",
    address: "Calle 1ra numero 10"
  },
  {
    id: '00124125311',
    name: 'Andres',
    lastName: "Lincold",
    secondLastName: "Barnes",
    province: "DO01",
    municipe: "DO0101",
    sector: "DO0101010103001",
    address: "Avenida quisqueya residencial maria segundo no.5"
  },
  {
    id: '22341457578',
    name: 'Jose',
    lastName: "Paulino",
    secondLastName: "Tolentino",
    province: "DO25",
    municipe: "DO2501",
    sector: "DO2501010100702",
    address: "Calle Comendador prolongacion 7"
  },
]